module.exports = __webpack_public_path__ + "98924c2856bf86003898cb89503a8e45.MP3";